<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <div class="font-normal mb-4 mx-4">
      <div>
        <div class="border-b">
          <p class="text-base font-bold pb-2.5">Filter Options</p>
        </div>
        <div>
          <el-form
            v-model="filterOptions"
            size="normal"
            label-position="top"
            label-width="80px"
          >
            <div class="flex items-center">
              <el-form-item label="Select Currency" class="mr-4">
                <el-select v-model="filterOptions.currency" placeholder="All">
                  <el-option
                    v-for="(currency, index) in currencies"
                    :key="index"
                    :label="currency.label"
                    :value="currency.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Date">
                <el-select v-model="filterOptions.date" placeholder="All">
                  <el-option
                    v-for="(date, index) in dates"
                    :key="index"
                    :label="date.label"
                    :value="date.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <!-- treasury -->
            <template v-if="filterType === 'treasury'">
              <div class="flex items-center">
                <el-form-item label="Amount" class="mr-4">
                  <el-select v-model="filterOptions.amount" placeholder="All">
                  </el-select>
                </el-form-item>
                <el-form-item label="Status">
                  <el-select v-model="filterOptions.status" placeholder="All">
                    <el-option
                      v-for="(status, index) in statuses"
                      :key="index"
                      :label="status.label"
                      :value="status.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <el-form-item label="Transaction Type" class="w-full">
                <el-select
                  class="w-full"
                  v-model="filterOptions.transactionType"
                  placeholder="All"
                >
                  <el-option
                    v-for="(transaction, index) in transactionType"
                    :key="index"
                    :label="transaction.label"
                    :value="transaction.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item label="Select Yield Type" class="w-full">
                <el-select
                  class="w-full"
                  v-model="filterOptions.yieldType"
                  placeholder="All"
                >
                  <el-option
                    v-for="(yieldd, index) in yieldType"
                    :key="index"
                    :label="yieldd.label"
                    :value="yieldd.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>
            <div class="flex justify-end gap-x-4 items-center mt-3">
              <div class="text-root-4 cursor-pointer">Reset</div>
              <div
                class="border-none rounded-3xl ml-2 w-24 px-3 py-3.5 flex items-center justify-center text-white bg-primary cursor-pointer"
              >
                Apply
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  name: 'FilterTransactionDialog',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    filterType: {
      type: String,
      default: ''
    }
  },
  components: {},
  data () {
    return {
      breakpoints,
      dates: [
        {
          label: 'From Newest',
          value: 1
        },
        {
          label: 'From Oldest',
          value: 2
        },
        {
          label: '7 Days',
          value: 3
        },
        {
          label: '30 Days',
          value: 4
        },
        {
          label: 'Custom',
          value: 5
        }
      ],
      currencies: [
        {
          label: 'OVF1',
          value: 1
        },
        {
          label: 'OVF2',
          value: 2
        }
      ],
      statuses: [
        {
          label: 'Initiated',
          value: 1
        },
        {
          label: 'Pending',
          value: 2
        },
        {
          label: 'Completed',
          value: 3
        },
        {
          label: 'Failed',
          value: 4
        }
      ],
      transactionType: [
        {
          label: 'Deposit',
          value: 1
        },
        {
          label: 'Withdrawal',
          value: 2
        }
      ],
      yieldType: [
        {
          label: 'OVF1',
          value: 1
        },
        {
          label: 'OVF2',
          value: 2
        }
      ],
      filterOptions: {
        currency: '',
        date: '',
        amount: '',
        status: '',
        transactionType: '',
        yieldType: ''
      }
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '37%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  }
}
</script>

<style scoped>
.grey-bg {
  background: #e0e0e0;
}
>>> .el-input__inner {
  border-radius: 6px;
  height: 55px;
  width: 100%;
}
</style>
